import { render, staticRenderFns } from "./SeparateMedication.vue?vue&type=template&id=880aa262&"
import script from "./SeparateMedication.vue?vue&type=script&lang=js&"
export * from "./SeparateMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports